import { POI, Scene } from '../../shared/types'

export enum ActionType {
  POI = 'poi',
  SCENE = 'scene',
}

export interface ActionItem {
  id: string
  label: string
  fullData?: POI | Scene
  type: ActionType.POI | ActionType.SCENE
  visited?: boolean
  locked?: boolean
}

export interface ActionsProps {
  actions: ActionItem[]
}
